// Sample Management Constants matching PRConstant.js style

export const getRequestTypeOptions = [
  { id: 1, name: "Brand", description: "Brand Sample Process (With Artwork & Branding)", code: "BRAND" },
  { id: 2, name: "Non-Brand", description: "Non-Brand Sample Process (Without Artwork - Grey/Yarn)", code: "NON_BRAND" },
];

export const getBusinessUnitOptions = [
  { id: 1, name: "Apparel", description: "Apparel Business Unit", code: "BU_APP" },
  { id: 2, name: "Textile", description: "Textile Business Unit", code: "BU_TEX" },
  { id: 3, name: "Innerwear", description: "Innerwear Business Unit", code: "BU_INN" },
  { id: 4, name: "Yarn", description: "Yarn & Spinning Unit", code: "BU_YARN" },
  { id: 5, name: "Home Textiles", description: "Home Textiles Unit", code: "BU_HT" },
];

export const getItemCategoryOptions = [
  { id: 1, name: "Men's Wear", description: "Men's Garments", code: "CAT_MEN" },
  { id: 2, name: "Women's Wear", description: "Women's Garments", code: "CAT_WOMEN" },
  { id: 3, name: "Kids Wear", description: "Kids Garments", code: "CAT_KIDS" },
  { id: 4, name: "Grey Fabric", description: "Grey Fabric", code: "CAT_GREY" },
  { id: 5, name: "Finished Fabric", description: "Finished Woven/Knitted Fabric", code: "CAT_FAB" },
  { id: 6, name: "Cotton Yarn 40s", description: "40s Combed Cotton Yarn", code: "CAT_YARN40" },
  { id: 7, name: "Cotton Yarn 60s", description: "60s Combed Cotton Yarn", code: "CAT_YARN60" },
];

export const getUomOptions = [
  { id: 1, name: "Nos", description: "Numbers", code: "NOS" },
  { id: 2, name: "Pcs", description: "Pieces", code: "PCS" },
  { id: 3, name: "Meters", description: "Meters", code: "MTR" },
  { id: 4, name: "Sets", description: "Sets", code: "SETS" },
  { id: 5, name: "Kgs", description: "Kilograms", code: "KGS" },
];

export const getBrandOptions = [
  { id: 1, name: "Ramraj", description: "Ramraj Brand", code: "RAMRAJ" },
  { id: 2, name: "Ramraj Cotton", description: "Ramraj Cotton", code: "RAMRAJ_COTTON" },
  { id: 3, name: "Genx", description: "Genx Innerwear", code: "GENX" },
];

